// extracted by mini-css-extract-plugin
export var benefits = "benefits-section-module--benefits--EcEJD";
export var buttonSection = "benefits-section-module--button-section--RMfFC";
export var cardSection = "benefits-section-module--card-section--w22OZ";
export var checklist = "benefits-section-module--checklist--KB9Pc";
export var checklistSection = "benefits-section-module--checklist-section--GWeK-";
export var checklist__element = "benefits-section-module--checklist__element---rksW";
export var hidden = "benefits-section-module--hidden--VttMI";
export var visible = "benefits-section-module--visible--9cNbX";